module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Teach us to number our days aright,")])]), _c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("that we may gain a heart of wisdom.")])]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 90:12")])]), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Do not cast me away when I am old;")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("do not forsake me when my strength is gone.")])]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 71:9")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "bl"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 66
// module chunks = 0